import React from "react"

/**
 * Componente de casilla de verificación.
 *
 * @component
 * @param {Object} props - Propiedades del componente.
 * @param {boolean} props.checked - Estado de la casilla de verificación.
 * @param {function} props.onChange - Función de cambio de estado.
 * @param {string} props.focusColor - Color de enfoque para la casilla de verificación.
 * @param {string} props.ariaLabel - Texto alternativo para la casilla de verificación.
 * @param {string} props.ariaDescribedBy - Identificador de la descripción para la casilla de verificación.
 * @param {string} props.name - Nombre de la casilla de verificación.
 * @param {boolean} props.disabled - Indica si la casilla de verificación está desactivada.
 * @param {string} props.id - Identificador de la casilla de verificación.
 * @returns {JSX.Element} Elemento JSX que representa el componente.
 */
export const CheckBox = ({ id, checked, onChange, focusColor, ariaLabel, ariaDescribedBy, name, disabled }) => {
    return (
            <input
                id={id}
                type={"checkbox"}
                className={`checkbox ${focusColor&&'focus'}`}
                checked={checked}
                name={name}
                aria-label={ariaLabel || 'Checkbox'}
                aria-describedby={ariaDescribedBy}
                disabled={disabled}
                onChange={(e) => onChange&&onChange(e)} /> 
    )
}
